import CalendarItemWithServiceParticipation from './CalendarItemWithServiceParticipation';

export default {
    ...CalendarItemWithServiceParticipation,
    name: 'service_participation_payment_status_resource',
};
